import React from 'react';

import { READINESS_DIMS, statusBg, statusBorder, statusColor, VISIT_TYPES } from '../../constants';
import { daysUntil, getPatient, overallReadiness } from '../../helpers';
import { StatusDot } from '../Badge';
import styles from './AppointmentCard.module.scss';

const AppointmentCard = ({ appt, onClick, isSelected }) => {
  const readiness = appt?.readiness || {};
  const patient = appt?.patient ?? getPatient(appt?.patientId);
  const visitType = VISIT_TYPES[appt.visitType];
  const overall = overallReadiness(readiness);
  const dimensions = Object.entries(readiness);
  const days = appt?.date ? daysUntil(appt.date) : null;
  const hasValidDays = Number.isFinite(days);
  const dateLabel = hasValidDays
    ? days === 0
      ? 'Today'
      : days === 1
        ? 'Tomorrow'
        : days < 0
          ? `${Math.abs(days)}d ago`
          : `in ${days}d`
    : '—';
  const isSoon = hasValidDays && days <= 2;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.card} ${isSelected ? styles.selected : ''}`}
      style={{
        '--card-bg': isSelected ? '#FAFAFA' : '#FFF',
        '--card-border': isSelected ? '#18181B' : statusBorder[overall],
        '--card-left': statusColor[overall],
      }}
    >
      <div className={styles.header}>
        <div>
          <div className={styles.patientName}>{patient?.name}</div>
          <div className={styles.visitType}>{visitType?.label || appt.visitType}</div>
        </div>
        <div className={styles.dateBlock}>
          <div className={`${styles.dateLabel} ${isSoon ? styles.dateSoon : styles.dateNormal}`}>
            {dateLabel}
          </div>
          <div className={styles.timeLabel}>{appt.time}</div>
        </div>
      </div>

      <div className={styles.dimensions}>
        {dimensions.map(([key, value]) => (
          <div
            key={key}
            className={styles.dimension}
            style={{
              '--dim-bg': statusBg[value.status],
              '--dim-border': statusBorder[value.status],
            }}
          >
            <StatusDot status={value.status} size={6} />
            <span className={styles.dimensionLabel}>{READINESS_DIMS[key]?.label || key}</span>
          </div>
        ))}
      </div>
    </button>
  );
};

export default AppointmentCard;
